import { Arch, Quadrant, Tooth } from '@libs/ui-lib';
import { AddNewTreatmentData } from '../add-treatment-modal/add-treatment-modal.vm';

export interface TeethSelectorDialogData {
  teeth: Tooth[];
  editing?: boolean;
  treatment?: AddNewTreatmentData;
  selectedTeeth: number[];
  selectedArches?: Arch[];
  selectedQuadrants?: Quadrant[];
  mode: TeethSelectorMode;
}

export interface TeethSelectorResult {
  selectedTeeth: number[];
  selectedArches: Arch[];
  selectedQuadrants: Quadrant[];
}

export interface RequiredInputConfig {
  quadrant?: Quadrant;
  arch?: Arch;
  position?: number;
}

export enum TeethSelectorMode {
  Full,
  Arch,
  Quadrant,
  SingleTooth,
  Range,
}
